<h2 mat-dialog-title class="pwa-install-dialog__title">Установка приложения</h2>

<div mat-dialog-content class="pwa-install-dialog__content">
    <ng-container *ngIf="data.platform === 'ios'; else androidInstructions">
        <p>Добавьте личный кабинет на экран «Домой»:</p>

        <ol class="pwa-install-dialog__steps">
            <li>
                <span class="pwa-install-dialog__step-number">1</span>
                <span
                    >Откройте меню браузера и нажмите «Поделиться», «Показать
                    больше».</span
                >
            </li>
            <li>
                <span class="pwa-install-dialog__step-number">2</span>
                <span>Выберите «На экран “Домой”».</span>
            </li>
            <li>
                <span class="pwa-install-dialog__step-number">3</span>
                <span>
                    Включите «Открывать как веб-приложение» и нажмите
                    «Добавить».
                </span>
            </li>
        </ol>
    </ng-container>

    <ng-template #androidInstructions>
        <p>Установите личный кабинет через меню браузера:</p>

        <ol class="pwa-install-dialog__steps">
            <li>
                <span class="pwa-install-dialog__step-number">1</span>
                <span>Откройте меню браузера — нажмите ⋮.</span>
            </li>
            <li>
                <span class="pwa-install-dialog__step-number">2</span>
                <span>
                    Выберите «Установить приложение» или «Добавить на главный
                    экран».
                </span>
            </li>
            <li>
                <span class="pwa-install-dialog__step-number">3</span>
                <span>Подтвердите установку.</span>
            </li>
        </ol>
    </ng-template>
</div>

<div mat-dialog-actions class="pwa-install-dialog__actions">
    <button type="button" class="pwa-install-dialog__close" mat-dialog-close>
        Понятно
    </button>
</div>
